// extracted by mini-css-extract-plugin
export var active = "_ke-2";
export var recordingDot = "_ke-1";
export var recordingIndicator = "_ke-0";